import { useEffect } from "react"
import { useApplicantGoalTrackingInfo } from "../../applicant/api/getApplicantGoalInfo";

export const GetGoalTrackingSettings = () => 
{
    const goalTrackingSettings = useApplicantGoalTrackingInfo();
    
    useEffect(() => {
      let goalTrackerEnabledEvent = new CustomEvent("goalTrackerSettings", {
          bubbles: true,
          cancelable: false,
          composed: true,
          detail: goalTrackingSettings
        });

        window.dispatchEvent(goalTrackerEnabledEvent);

    }, [goalTrackingSettings]);

    return (<></>);
}